import React, {Fragment,useState,useEffect,useRef,Suspense} from 'react';
import { Table,Row, Col,
  Card, CardBody,
  CardTitle,Button } from 'reactstrap';
  import Parametri from '../../parametri';

import FormGridFormRow from '../SchedaTesseram/FormGridFormRow';

import TabellaRicerca from '../tabellaricerca.js';
import FormGridFormRow2 from '../SchedaRinnovamentoMassivoTesseram/FormGridFormRow';

import TrasformaDateAUmano from '../TrasformaDateAUmano.js';

import Clessidra from '../Clessidra.js';

import { calcolaAnnoOggi } from '../../funzioni.js';
import Interrogativo from '../../immagini/interrogativo-azzurro.png';

import Modale from '../Modale.js';


//const STATO_INDEFINITO = 0;
const STATO_RICERCA_DATI = 1;
const STATO_OPERAZIONE_CORRETTA= 2;
const STATO_ERRORE_CONNESSIONE= 3;
const STATO_VAI_IN_MODIFICA= 4;
const STATO_VAI_IN_ELIMINA= 5;
const STATO_VAI_IN_INSERISCI= 6;
const STATO_RICERCA_DATI_PERSONA =7;
const STATO_VAI_IN_RINNOVA= 8;


function TabellaTesseram(props) {
    
    const operazione = "elencoTesseram";

    const  dataPartenza = useRef();

    const annoOggi = calcolaAnnoOggi(props.identitaSelezionata.data_chiusura_esercizio);
    const [dataPartenzaDefault,setDataPartenzaDefault]=useState(annoOggi);
    const [inizioPeriodo,setInizioPeriodo]=useState('');
    const [finePeriodo,setFinePeriodo]=useState('');

    let idPersona = '';

    const [risultatoServer,setRisultatoServer]=useState('');
    const [statoPagina,setStatoPagina]=useState(STATO_RICERCA_DATI);
    const [error,setError]=useState('');

    const [idModifica,setIdModifica]=useState('');
    
    const [datiPersonaFiltrata, setDatiPersonaFiltrata]=useState('');
    const [flagModaleInfoPopolamento, setFlagModaleInfoPopolamento] = React.useState(false);
  
    // nota: accessor DEVE chiamarsi così a causa di requisiti dei componenti usati, non fatti da mez
    const colonne = [
      {
        etichetta: '',
        accessor: 'ID'
      },
      {
        etichetta: 'Cognome',
        accessor: 'COGNOME',
        pdf: 1,
      },
      {
        etichetta: 'Nome',
        accessor: 'NOME',
        pdf: 1,
      },
      {
        etichetta: 'Numero Tessera',
        accessor: 'NUMERO_TESSERA',
        pdf: 1,
      },
      {
        etichetta: 'Ente',
        accessor: 'ENTE',
        pdf: 1,
      },
      {
        etichetta: 'Num. Tessera Ente',
        accessor: 'NUMERO_TESSERA_ENTE',
        pdf: 1,
      },
      {
        etichetta: 'Data Inizio',
        accessor: 'DATA_INIZIO',
        pdf: 1,
      },
      {
        etichetta: 'Data Fine',
        accessor: 'DATA_FINE',
        pdf: 1,
      },
      {
        etichetta: 'Tipo',
        accessor: 'DESCRIZIONE_TIPO',
        pdf: 1,
      },
      {
        etichetta: 'Categoria',
        accessor: 'DESCRIZIONE_CATEGORIA',
        pdf: 1,
      },
    ];
    const arrayTipiDati=[];
    arrayTipiDati[6]="data";
    arrayTipiDati[7]="data";


    const colonnePaginaFiltrata = [
      {
        etichetta: '',
        accessor: 'ID'
      },
      {
        etichetta: 'Ente',
        accessor: 'ENTE'
      },
      {
        etichetta: 'Num. Tessera Ente',
        accessor: 'NUMERO_TESSERA_ENTE'
      },
      {
        etichetta: 'Data Inizio',
        accessor: 'DATA_INIZIO'
      },
      {
        etichetta: 'Data Fine',
        accessor: 'DATA_FINE'
      },
      {
        etichetta: 'Tipo',
        accessor: 'DESCRIZIONE_TIPO'
      },
      {
        etichetta: 'Categoria',
        accessor: 'DESCRIZIONE_CATEGORIA'
      },
    ];
    const arrayTipiDatiPaginaFiltrata=[];
    arrayTipiDatiPaginaFiltrata[3]="data";
    arrayTipiDatiPaginaFiltrata[4]="data";

    function VaiModifica(id) {
      setStatoPagina(STATO_VAI_IN_MODIFICA);
      setIdModifica(id);
    }

    function VaiElimina(id) {
      setStatoPagina(STATO_VAI_IN_ELIMINA);
      setIdModifica(id);
    }

    function callbackTermineModifica() {
      setStatoPagina(STATO_RICERCA_DATI);
    }
    function tornaElenco() {
      setFlagModaleInfoPopolamento(false);
    }

    useEffect(() => {
      if (props.flagResetPagine) {
        setStatoPagina(STATO_RICERCA_DATI);
        props.callbackFlagResetPagine(false);
      }
    }, [props.flagResetPagine])

    useEffect(() => {
      //resetto tutte le var di stato:
      setRisultatoServer(['']);
      setStatoPagina(STATO_RICERCA_DATI);    
    },[dataPartenzaDefault])

    useEffect(() => {
      
      if(statoPagina===STATO_RICERCA_DATI){

        if(props.idPersona !== undefined) idPersona = props.idPersona;
        
        // parametri per inviare i dati al server:
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:operazione,idElemento:idPersona,dataPartenza:dataPartenzaDefault,emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
            (valoreDiRitorno) => {
              if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
              }
              if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
              if(valoreDiRitorno.risultatoOperazione===1){
                setRisultatoServer(valoreDiRitorno.risultatoRitorno);
                setInizioPeriodo(valoreDiRitorno.periodo[0].DATA_INIZIO_PERIODO);
                setFinePeriodo(valoreDiRitorno.periodo[0].DATA_FINE_PERIODO);
                if(props.idPersona>0){
                  ricercaDatiPersona(props.idPersona);
                }else{
                  setStatoPagina(STATO_OPERAZIONE_CORRETTA);
                }
                }
              },
          (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
          );
      }    
    },[statoPagina])
    //},[props.numPagina])

    function ricercaDatiPersona(persona){
      //ricerco i dati della persona della quale ho l'id nella props:
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:"personeRecuperaDati",id:persona,recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
      };

      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
          (valoreDiRitorno) => {
              //setRisultatoServerDatiPersona(valoreDiRitorno.risultatoRitorno);
              //compongo quidi i dati della persona:
              if(valoreDiRitorno.risultatoRitorno !== undefined && valoreDiRitorno.risultatoRitorno !== ""){
                let componiPersona = "";
                if(valoreDiRitorno.risultatoRitorno[0].COGNOME !== '' && valoreDiRitorno.risultatoRitorno[0].COGNOME !== undefined) componiPersona = componiPersona + valoreDiRitorno.risultatoRitorno[0].COGNOME;
                if(valoreDiRitorno.risultatoRitorno[0].NOME !== '' && valoreDiRitorno.risultatoRitorno[0].NOME !== undefined && componiPersona !== "")  componiPersona = componiPersona + " ";
                if(valoreDiRitorno.risultatoRitorno[0].NOME !== '' && valoreDiRitorno.risultatoRitorno[0].NOME !== undefined)  componiPersona = componiPersona + valoreDiRitorno.risultatoRitorno[0].NOME;
                if(valoreDiRitorno.risultatoRitorno[0].NUMERO_TESSERA !== '' && valoreDiRitorno.risultatoRitorno[0].NUMERO_TESSERA !== undefined && componiPersona !== "")  componiPersona = componiPersona + " ";
                if(valoreDiRitorno.risultatoRitorno[0].NUMERO_TESSERA !== '' && valoreDiRitorno.risultatoRitorno[0].NUMERO_TESSERA !== undefined)  componiPersona = componiPersona + "("+valoreDiRitorno.risultatoRitorno[0].NUMERO_TESSERA+")";
                setDatiPersonaFiltrata(componiPersona);
              }
              setStatoPagina(STATO_OPERAZIONE_CORRETTA);
          },
          (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
          );
  }
    function callbackRinnTesseramenti() {
      setStatoPagina(STATO_RICERCA_DATI);
    }

  return (
      <div>
      
      {statoPagina === STATO_VAI_IN_RINNOVA ? 
      
      <div>
      <Suspense fallback={
        <div className="loader-container">
        <div className="loader-container-inner"><h6 className="mt-5">Caricamento scheda inserimento massivo e/o rinnovamento tesseramenti in corso...</h6></div>
        </div>
      }>

      <FormGridFormRow2  {...props}
      ope={"rinnova"} 
      callbackRinnTesseramenti={callbackRinnTesseramenti} 
      sessionId={props.sessionId}></FormGridFormRow2>
      </Suspense>
      </div>
      :""} 

      {statoPagina === STATO_VAI_IN_INSERISCI ? 
        <div>
        <Suspense fallback={
          <div className="loader-container">
          <div className="loader-container-inner"><h6 className="mt-5">Caricamento scheda tesseramento in corso...</h6></div>
          </div>
        }>
        <FormGridFormRow {...props} ope={"inserisci"} idPersona={props.idPersona} callbackTermineModifica={callbackTermineModifica} sessionId={props.sessionId}></FormGridFormRow>
        </Suspense>
      </div>
      :""} 

      {statoPagina === STATO_VAI_IN_MODIFICA ? 
        <div>
          <Suspense fallback={
            <div className="loader-container">
            <div className="loader-container-inner"><h6 className="mt-5">Caricamento scheda tesseramento in corso...</h6></div>
            </div>
          }>
          <FormGridFormRow {...props} id={idModifica} ope={"modifica"} callbackTermineModifica={callbackTermineModifica} sessionId={props.sessionId}></FormGridFormRow>
          </Suspense>
        </div>
      :""} 

      {statoPagina === STATO_VAI_IN_ELIMINA ? 
        <div>
          <Suspense fallback={
            <div className="loader-container">
            <div className="loader-container-inner"><h6 className="mt-5">Caricamento scheda tesseramento in corso...</h6></div>
            </div>
          }>
          <FormGridFormRow {...props} id={idModifica} ope={"cancella"} callbackTermineModifica={callbackTermineModifica} sessionId={props.sessionId}></FormGridFormRow>
          </Suspense>
        </div>
      :""} 

      {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1E_Tesse</div> :""}  
      {statoPagina === STATO_RICERCA_DATI ?   <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
                </div>
                </div> :""}
      {statoPagina === STATO_RICERCA_DATI_PERSONA ?  <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
                </div>
                </div> :""}

      {statoPagina === STATO_OPERAZIONE_CORRETTA ?
        <div style={{height: props.dimensioniApp.yMain, overflow:"hidden", display:"flex", flexDirection:"column"}}>
                  {flagModaleInfoPopolamento=== true ?
                    <Modale 
                        larghezza = "lg"
                        titolo="Informativa Tesseramenti"
                        flagErrore={false}
                        contenuto={<div>
                        Questo ambiente offre una gestione completa dei tesseramenti per gli iscritti agli Enti di riferimento, come Federazioni o altri Enti a cui la Società è affiliata. 
                        <br></br>Grazie a questa funzionalità, è possibile tesserare i nuovi iscritti o rinnovare i tesseramenti esistenti.
                        <br></br>
                        <br></br>
                        La tendina "Feder./Ente di Tesseramento" viene popolata con i dati inseriti preventivamente nell'ambiente Tesseramenti - Feder / Enti di Tesseramento.
                        <br></br><br></br>
                        <p style={{ textAlign: 'left' }}>
                        Sono disponibili due modalità operative:
                        <br></br>
                        - Inserimento Singolo Dettagliato: consente di gestire il tesseramento di un singolo iscritto con tutti i dettagli necessari.
                        <br></br>
                        - Inserimento e/o Rinnovamento Massivo: permette di effettuare operazioni su più iscritti contemporaneamente, semplificando la gestione di grandi volumi di tesseramenti.
                        </p>
                        </div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {tornaElenco()}
                            }    
                        ]}
                    />
                :""}
                    <CardBody>
                            <CardTitle>Elenco Tesseramenti
                            {props.idPersona>0 ? <div>(filtrato per l'iscritto {datiPersonaFiltrata})
                            </div> :""}

                            &nbsp;
                            <select
                              name="dataPartenza"
                              id="dataPartenza"
                              innerRef={dataPartenza}
                              onChange={(e) => setDataPartenzaDefault(e.target.value)}
                            >
                              {/* Significato di (_, i) => { ... }
                              Il primo parametro _ rappresenta l'elemento corrente dell'array. In questo caso, l'array è creato con [...Array(annoOggi - 2014 + 1)], quindi è un array di elementi "vuoti" (tipo [undefined, undefined, ...]). Poiché non ci interessa il valore degli elementi, usiamo _ per indicare che non lo utilizziamo.
                              Il secondo parametro i rappresenta l'indice corrente dell'iterazione (parte da 0 e cresce di 1 per ogni iterazione).*/}
                              {[...Array((annoOggi+1) - 2014 + 1)].map((_, i) => {
                                const anno = annoOggi+1  - i;
                                return (
                                  <option key={anno} value={anno} selected={parseInt(dataPartenzaDefault) === anno}>
                                    {anno}
                                  </option>
                                );
                              })}
                            </select>
                            {/*}
                            <select name="dataPartenza" id="dataPartenza" innerRef={dataPartenza} onChange={(e)=>{setDataPartenzaDefault(e.target.value)}}>
                              {parseInt(dataPartenzaDefault) === annoOggi ? <option selected value={annoOggi}>{annoOggi}</option> : <option value={annoOggi}>{annoOggi}</option>}
                              {parseInt(dataPartenzaDefault) === annoOggi-1 ? <option selected value={annoOggi-1}>{annoOggi-1}</option> : <option value={annoOggi-1}>{annoOggi-1}</option>}
                              {parseInt(dataPartenzaDefault) === annoOggi-2 ? <option selected value={annoOggi-2}>{annoOggi-2}</option> : <option value={annoOggi-2}>{annoOggi-2}</option>}
                              {parseInt(dataPartenzaDefault) === annoOggi-3 ? <option selected value={annoOggi-3}>{annoOggi-3}</option> : <option value={annoOggi-3}>{annoOggi-3}</option>}
                              {parseInt(dataPartenzaDefault) === annoOggi-4 ? <option selected value={annoOggi-4}>{annoOggi-4}</option> : <option value={annoOggi-4}>{annoOggi-4}</option>}
                              {parseInt(dataPartenzaDefault) === annoOggi-5 ? <option selected value={annoOggi-5}>{annoOggi-5}</option> : <option value={annoOggi-5}>{annoOggi-5}</option>}
                              {parseInt(dataPartenzaDefault) === annoOggi-6 ? <option selected value={annoOggi-6}>{annoOggi-6}</option> : <option value={annoOggi-6}>{annoOggi-6}</option>}
                              {parseInt(dataPartenzaDefault) === annoOggi-7 ? <option selected value={annoOggi-7}>{annoOggi-7}</option> : <option value={annoOggi-7}>{annoOggi-7}</option>}
                              {parseInt(dataPartenzaDefault) === annoOggi-8 ? <option selected value={annoOggi-8}>{annoOggi-8}</option> : <option value={annoOggi-8}>{annoOggi-8}</option>}
                              {parseInt(dataPartenzaDefault) === annoOggi-9 ? <option selected value={annoOggi-9}>{annoOggi-9}</option> : <option value={annoOggi-9}>{annoOggi-9}</option>}
                              {parseInt(dataPartenzaDefault) === annoOggi-10 ? <option selected value={annoOggi-10}>{annoOggi-10}</option> : <option value={annoOggi-10}>{annoOggi-10}</option>}
                            </select>  */}  
                            &nbsp;Attivi dal <TrasformaDateAUmano data={inizioPeriodo}></TrasformaDateAUmano> al <TrasformaDateAUmano data={finePeriodo}></TrasformaDateAUmano> 

                            </CardTitle>
                            {props.idPersona>0 ? "" 
                            :
                            <Button color="success" onClick={() => setStatoPagina(STATO_VAI_IN_RINNOVA)}>Inserimento e/o Rinnovamento Massivo</Button>}
                            {props.idPersona>0 ? <Button color="success" className="bottoneMargineASinistra" onClick={() => setStatoPagina(STATO_VAI_IN_INSERISCI)}>Nuovo</Button>
                            :
                            <Button color="success" className="bottoneMargineASinistra" onClick={() => setStatoPagina(STATO_VAI_IN_INSERISCI)}>Inserimento Singolo Dettagliato</Button>}
                            <img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagModaleInfoPopolamento(true)}/>
                            </CardBody>
                        
                            {risultatoServer !== undefined && risultatoServer !== "" ?
                              props.idPersona>0 ?
                                <TabellaRicerca 
                                titolo={`Elenco Tesseramenti ${parseInt(dataPartenzaDefault)}`} 
                                columns={colonnePaginaFiltrata} data={risultatoServer} arrayTipiDati={arrayTipiDatiPaginaFiltrata} campoChiave={0} campoOrdinamento={3} nascondiColonna={0} callbackSelezionaElemento={VaiModifica} callbackEliminaElemento={VaiElimina}/>
                              :
                                <TabellaRicerca 
                                titolo={`Elenco Tesseramenti ${parseInt(dataPartenzaDefault)}`} 
                                columns={colonne} data={risultatoServer} arrayTipiDati={arrayTipiDati} campoChiave={0} campoOrdinamento={6} ordinamentoDecrescente={true} nascondiColonna={0} callbackSelezionaElemento={VaiModifica} callbackEliminaElemento={VaiElimina}/>
                            : 
                              <Table responsive bordered hover striped className="mb-0">
                              <thead>
                                <tr>
                                  <th>Nessun dato presente</th>
                                </tr>
                              </thead>
                              </Table>
                          }
                      
        </div>
      :""}
    </div>
   );
}
export default TabellaTesseram;